"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./campaignDescriptionBlock.scss");
const campaignDescriptionBlockTranslations_json_1 = __importDefault(require("./campaignDescriptionBlockTranslations/campaignDescriptionBlockTranslations.json"));
const master_1 = require("../../../constants/master");
const subdomains_1 = require("../../../constants/subdomains");
function CampaignDescriptionBlock(props) {
    props.addTranslation(campaignDescriptionBlockTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    function getDescriptionTranslationKey() {
        return config.subDomain === subdomains_1.himssSubdomain
            ? "certificateDescription"
            : "credentialDescription";
    }
    return (react_1.default.createElement("div", { className: "campaign-description-block" },
        config.subDomain !== subdomains_1.nationalBlackLawyersSubdomain &&
            config.subDomain !== subdomains_1.nationalTrialLawyersSubdomain && (react_1.default.createElement("span", { className: "description-title" }, props.translate(getDescriptionTranslationKey()).toString())),
        props.descriptionHtml ? (react_1.default.createElement("div", { className: "ql-editor", dangerouslySetInnerHTML: {
                __html: props.descriptionHtml,
            } })) : (react_1.default.createElement("span", { className: "description-text" }, props.description))));
}
exports.default = CampaignDescriptionBlock;
